import { Alert, Form, Image, Input, message, Row, Select, Steps } from "antd";
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import * as appRoutes from "config/routes.config";
import { Dispatch, FC, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import * as TEACHER_SERVICES from "../../../api/services/teacher/teacher.services";

//!COMPONENTS
import Container from "components/container";

//!IMAGES
import organisation from "../../../assets/images/app/home/organisation.svg";

//!STYLES
import { getCountryCode, StatusCode } from "common/enums";
import Breadcrumbs from "components/breadcrumbs";
import AppButton from "components/libs/button";
import H1 from "components/libs/title";
import React from "react";
import PhoneInput from "react-phone-input-2";
import fr from "react-phone-input-2/lang/fr.json";
import FormStep from "screens/teacher/profileComplete/component";
import { setIsRegistering } from "store/app/appSlice";
import { registerParentOrganisationWithEmailPassword } from "store/auth/authSlice";
import { useCheckEmailMutation } from "store/services/app/user.services";
import AnimatedPage from "utils/animatedPage";
import s from "./assets/register.module.css";
import StepTwo from "./stepTwo";

import EmailOTPModal from "components/OTP/emailVerification";
import PhoneOTPModal from "components/OTP/phoneVerification";
import { fetchSignInMethodsForEmail } from "firebase/auth";
import { appAuth, RecaptchaVerifier } from "../../../config/firebase.config";

const { Step } = Steps;
const { Option } = Select;

declare global {
    interface Window {
        recaptchaVerifier: any;
    }
}

const RegisterOrganisme: FC = () => {

    //!HOOKS
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const auth = useSelector((state: RootStateOrAny) => state.auth);
    const [formInfos] = Form.useForm();
    const { user, isAppInMaintenance } = useSelector((state) => state.auth);
    const isLoggedIn = auth.isLoggedIn;

    //!STATES
    const [current, setCurrent] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [checkEmail, { isSuccess, isError, data }] = useCheckEmailMutation();
    const [accountType, setAccountType] = useState<string>("Organisme");
    const [countriesList, setCountries] = useState<any>([]);
    const [dataList] = useState<any>([]);

    //!STATES JOFREY
    const [registrationData, setRegistrationData] = useState<any>({});
    const [errorEmail, setErrorEmail] = useState<boolean>(false);
    const [userEmail, setUserEmail] = useState<string>("");
    const [userPhoneNumber, setUserPhoneNumber] = useState<string>("");

    const [openPhoneVerification, setOpenPhoneVerification] = useState<boolean>(false);
    const [openEmailVerification, setOpenEmailVerification] = useState<boolean>(false);
    const [confirmationResult, setConfirmationResult] = useState<any>(null);

    //!CONSTANTS
    const validateMessages = {
        required: t("auth.error.required"),
        types: {
            email: t("auth.error.emailInvalid"),
        },
    };

    const handlePhoneChange = (value: string) => {
        setUserPhoneNumber("+" + value);
    };

    const handleVerify = (otp: string) => {
        // Call Firebase confirm() or your backend verification
        verifyOtp(otp);
    };

    // Setup invisible reCAPTCHA
    const setUpRecaptcha = () => {
        if (!window.recaptchaVerifier) {
            window.recaptchaVerifier = new RecaptchaVerifier(
                "recaptcha-container",
                { size: "invisible" },
                appAuth
            );
        }
    };

    // Step 1: Send OTP
    const sendOtp = async () => {
        try {
            const response = await AUTH_SERVICES.requestPhoneOTP(userPhoneNumber);
            if (response?.statusCode === StatusCode.CREATED) {
                setOpenPhoneVerification(true);
                setIsLoading(false);
                message.success(`Nous avons envoyé un code par SMS au ${userPhoneNumber}`);
            }
        } catch (error: any) {
            setIsLoading(false);
        }
    };

    // Step 2: Verify OTP
    const verifyOtp = async (otp: string) => {
        try {
            setIsLoading(true);
            const response = await AUTH_SERVICES.verifyPhoneOTP(userPhoneNumber, otp);
            if (response?.statusCode === StatusCode.CREATED) {
                message.success("Code vérifié avec succès !");
                setOpenPhoneVerification(false);
                await AUTH_SERVICES.requestOTP(userEmail, "organisme");
                setOpenEmailVerification(true);
                setIsLoading(false);
            }
        } catch (error) {
            console.error(error);
            message.error("Code invalide !");
            setIsLoading(false);
        }
    };

    const registerUser = async (values: any) => {
        setRegistrationData(values);
        setIsLoading(true);

        try {
            console.error("Firebase checking email...");
            const methods = await fetchSignInMethodsForEmail(appAuth, values.email);

            if (methods.length > 0) {
                // Email already has an account
                setCurrent(1);
                setErrorEmail(true);
                setIsLoading(false);
                return;
            } else {
                // Email is available
                console.error("Mongo checking email...");
                checkEmail({ email: values.email }).then(async (value: any) => {
                    const valueData = value?.data;
                    if (valueData?.data?.found) {
                        setCurrent(1);
                        setErrorEmail(true);
                        setIsLoading(false);
                    }
                    else {
                        setUserEmail(values.email);
                        //sendOtp();
                        await AUTH_SERVICES.requestOTP(values.email, "organisme");
                        setOpenEmailVerification(true);
                        setIsLoading(false);
                    }
                });
            }

        } catch (error) {
            console.error("Error checking email:", error);
            return false;
        }
    }

    const handleOtpSubmit = async (otp: string) => {
        try {
            setIsLoading(true);
            const response = await AUTH_SERVICES.validateOTP(userEmail, otp);
            if (response?.data?.success === true) {
                const finalData = {
                    ...registrationData,
                    roles: ["organisme"],
                    step: "",
                    organisationName: registrationData.organisationName,
                    listInvite: [],
                    whatsappEnabled: false,
                    phone: userPhoneNumber?.split("+")[1],
                    emailVerified: true,
                };

                await dispatch(registerParentOrganisationWithEmailPassword(finalData));
                await dispatch(setIsRegistering(true));
                setOpenEmailVerification(false);
                setCurrent(2);
            }
            else {
                message.warning({
                    content: "Ce code est invalide !, consulte tes mails et entre le code reçu.",
                });
            }
        } catch (error: any) {
            let content = "";
            for (
                let index = 0;
                index < error?.response?.data?.message?.length;
                index++
            ) {
                content = error?.response?.data?.message[index] + ", " + content;
            }
            message.error({
                content: content,
            });
        }
        finally {
            setIsLoading(false);
        }
    };

    const getStaticLists = useCallback(
        async (type: string, dataList: any, state: Dispatch<any>) => {
            const response = await TEACHER_SERVICES.getDataList(type);
            if (response?.statusCode === StatusCode.OK) {
                state(response?.data);
            }
        },
        [dataList]
    );

    const [selectedCountryCode, setSelectedCountryCode] = useState<any>("fr");

    const handleCountryChange = (countryName: any) => {
        const countryCode = getCountryCode(countryName);
        if (countryCode) {
            const code = countryCode?.toLowerCase();
            setSelectedCountryCode(code);
        }
        else {
            setSelectedCountryCode("fr");
        }
    };

    //!EFFECTS
    useEffect(() => {
        getStaticLists('pays', countriesList, setCountries);
    }, []);

    useEffect(() => {
        if (isAppInMaintenance) {
            navigate(appRoutes.MAINTENANCE);
        };
    }, [isAppInMaintenance]);

    return (
        <>
            <AnimatedPage>
                <Breadcrumbs />
                <div className={s.register__teacher}>
                    <Container>

                        <div className={s.content__action}>
                            <div className={s.teacher}>
                                <div className={s.avatar}>
                                    <Image
                                        preview={false}
                                        width={60}
                                        src={organisation}
                                        alt="Organisme"
                                    />
                                </div>

                                <div className={s.header__text}>
                                    <H1>Créez votre compte organisme</H1>
                                    <p>
                                        Je suis <span style={{ color: "#000" }}>un organisme</span>.{" "}
                                        {current === 1 && <Link to={appRoutes.LOGINS}>Modifier</Link>}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className={s.step}>
                            <Steps current={current - 1} labelPlacement={"vertical"} responsive={true}>
                                <Step
                                    style={{ cursor: "pointer" }}
                                    title={
                                        <div className={s.title__step}>
                                            <span>Informations personnelles</span>
                                        </div>
                                    }
                                    onClick={() => setCurrent(current)}
                                />
                                <Step
                                    style={{ cursor: "pointer" }}
                                    title={
                                        <div className={s.title__step}>
                                            <span>Invitez vos élèves</span>
                                        </div>
                                    }
                                    onClick={() => setCurrent(current)}
                                />
                            </Steps>
                        </div>
                        <div className={s.step_container}>
                            <FormStep index={1} title="Informations personnelles" current={current} onClick={() => setCurrent(current)} />
                            <FormStep index={2} title="Invitez vos élèves" current={current} onClick={() => setCurrent(current)} />
                        </div>
                        <div className={s.formBox}>
                            <div className={`${current === 1 ? s.form__container : ""}`}>
                                <Form
                                    validateTrigger={["onFinish"]}
                                    validateMessages={validateMessages}
                                    name="registerParent"
                                    autoComplete="off"
                                    form={formInfos}
                                    onFinish={registerUser}
                                >
                                    {current === 1 && (
                                        <React.Fragment>

                                            <div className={s.field} style={{ marginBottom: "20px" }}>
                                                <Form.Item
                                                    name="account"
                                                    rules={[{ required: false }]}
                                                >
                                                    <Select
                                                        placeholder="Organisme"
                                                        style={{ width: "100%", color: "#000", paddingTop: "5px", fontSize: "14px" }}
                                                        bordered={false}
                                                        allowClear
                                                    >
                                                        <Option
                                                            key={1}
                                                            value={"Organisation"}
                                                        >
                                                            {"Organisme"}
                                                        </Option>
                                                    </Select>
                                                </Form.Item>
                                            </div>

                                            <Form.Item
                                                name="organisationName"
                                                rules={[{ required: true }]}
                                                style={{ marginBottom: "20px" }}
                                            >
                                                <Input
                                                    className={s.field}
                                                    placeholder={"Nom de l'organisation"}
                                                    maxLength={30}
                                                />
                                            </Form.Item>

                                            <Form.Item
                                                name="firstname"
                                                rules={[{ required: true }]}
                                                style={{ marginBottom: "20px" }}
                                            >
                                                <Input
                                                    className={s.field}
                                                    placeholder={"Prénom du responsable"}
                                                    maxLength={30}
                                                />
                                            </Form.Item>

                                            <Form.Item
                                                name="lastname"
                                                rules={[{ required: true }]}
                                                style={{ marginBottom: "20px" }}
                                            >
                                                <Input
                                                    className={s.field}
                                                    placeholder={"Nom du responsable"}
                                                    maxLength={30}
                                                />
                                            </Form.Item>

                                            <Form.Item
                                                name="email"
                                                rules={[{ required: true }, { type: "email" }]}
                                                style={{ marginBottom: "20px" }}
                                            >
                                                <Input
                                                    type="email"
                                                    className={s.field}
                                                    placeholder={"Email du responsable"}
                                                />
                                            </Form.Item>

                                            <Form.Item
                                                style={{ marginBottom: "20px" }}
                                                name="countries"
                                                rules={[{ required: true }]}
                                            >
                                                <Select
                                                    showSearch
                                                    style={{ padding: "5px 0px 5px 0px", fontSize: "14px" }}
                                                    className={s.selectInput}
                                                    placeholder={<div className={s.placeholderStyle}>Pays de résidence</div>}
                                                    optionFilterProp="children"
                                                    bordered={false}
                                                    allowClear
                                                    dropdownStyle={{ padding: "3px" }}
                                                    showArrow={true}
                                                    onChange={handleCountryChange}
                                                >
                                                    {countriesList.map((item: any, i: any) => (<Select.Option key={i} value={item}>{item}</Select.Option>))}
                                                </Select>
                                            </Form.Item>

                                            <Form.Item
                                                hasFeedback
                                                label={null}
                                                name="phone"
                                                rules={[{ required: false }]}
                                                style={{ marginBottom: "20px" }}
                                            >
                                                <PhoneInput
                                                    inputProps={{
                                                        name: "phone",
                                                        required: true,
                                                        autoFocus: true,
                                                        className: `ant-input ant-input-lg ${s.field}`,
                                                        style: {
                                                            paddingLeft: "50px",
                                                        },
                                                    }}
                                                    onChange={handlePhoneChange}
                                                    placeholder={"Numéro de téléphone (optionnel)"}
                                                    enableSearch
                                                    specialLabel=""
                                                    country={selectedCountryCode}
                                                    localization={fr}
                                                    countryCodeEditable={false}
                                                />
                                            </Form.Item>

                                            <Form.Item
                                                name="password"
                                                rules={[
                                                    { required: true },
                                                    {
                                                        pattern: /^.{6,}$/,
                                                        message: "Le mot de passe doit contenir au moins 6 caractères !",
                                                    },
                                                ]}
                                                style={{ marginBottom: "20px" }}
                                            >
                                                <Input.Password
                                                    className={s.field}
                                                    placeholder={t("auth.password")}
                                                />
                                            </Form.Item>

                                            <Form.Item
                                                name="confirmPassword"
                                                rules={[
                                                    { required: true },
                                                    ({ getFieldValue }) => ({
                                                        validator(_: any, value: any) {
                                                            if (!value || getFieldValue("password") === value) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(
                                                                new Error("Les mots de passe ne correspondent pas :(")
                                                            );
                                                        },
                                                    }),
                                                ]}
                                                style={{ marginBottom: "20px" }}
                                            >
                                                <Input.Password
                                                    className={s.field}
                                                    placeholder={"Confirmez votre mot de passe"}
                                                />
                                            </Form.Item>

                                            <Row justify="center" style={{ marginTop: "30px" }}>
                                                <Form.Item>
                                                    <AppButton loading={isLoading} htmlTypeSubmit={true}><a className={s.nextButton}>SUIVANT</a></AppButton>
                                                </Form.Item>
                                            </Row>
                                        </React.Fragment>
                                    )}
                                </Form>

                                {current === 2 && (
                                    <React.Fragment>
                                        <StepTwo
                                            stepOneData={registrationData}
                                            setCurrent={setCurrent}
                                        />
                                    </React.Fragment>
                                )}

                                {!isLoggedIn && auth.registerErrors.length > 0 &&
                                    auth.registerErrors.map((error: any, index: any) => (
                                        <Alert key={index} message={error} type="error" showIcon />
                                    ))}

                                {errorEmail && <Alert message={"Cette adresse email est déjà utilisée"} type="error" showIcon />}

                                {current === 1 && <div
                                    className={s.text}
                                    style={{ marginTop: "1em", textAlign: "center" }}
                                >
                                    <p>
                                        Vous avez déjà un compte ?{" "}
                                        <Link to={appRoutes.LOGINS}>Connectez-vous</Link>
                                    </p>
                                </div>}
                            </div>
                        </div>
                        <div id="recaptcha-container"></div>
                    </Container>
                </div>
            </AnimatedPage>
            <PhoneOTPModal
                visible={openPhoneVerification}
                phone={userPhoneNumber}
                onCancel={() => setOpenPhoneVerification(false)}
                onVerify={handleVerify}
                onResend={sendOtp}
                isLoading={isLoading}
            />
            <EmailOTPModal
                visible={openEmailVerification}
                email={userEmail}
                onCancel={() => setOpenEmailVerification(false)}
                onSubmitOtp={handleOtpSubmit}
                isLoading={isLoading}
            />
        </>
    );
};

export default RegisterOrganisme;
